<a *ngIf="isExternalLink(item().route); else internalLink"
   class="menu-item"
   mat-list-item
   [href]="item().route"
   target="_blank"
   rel="noopener noreferrer">

    <mat-icon matListItemIcon>{{ item().icon }}</mat-icon>

    @if (!collapsed()) {
        <span style="font-weight: bold; color: #4b4b4b;" matTooltip="{{ item().label }}" matListItemTitle>
      {{ item().label }}
    </span>
    }
</a>

<ng-template #internalLink>
    <a class="menu-item"
       mat-list-item
       [routerLink]="item().subItems ? null : item().route"
       (click)="toggleNested()"
       routerLinkActive="selected-menu-item"
       [routerLinkActiveOptions]="{ exact: true }" 
       #rla="routerLinkActive"
       [activated]="rla.isActive">

        <mat-icon matListItemIcon>{{ item().icon }}</mat-icon>

        @if (!collapsed()) {
            <span style="font-weight: bold; color: #4b4b4b;" matTooltip="{{ item().label }}" matListItemTitle>
        {{ item().label }}
      </span>
        }

        @if (item().subItems) {
            <span class="expand" matListItemMeta>
        @if(nestedMenuOpen()){
            <mat-icon>expand_less</mat-icon>
        } @else {
            <mat-icon>expand_more</mat-icon>
        }
      </span>
        }
    </a>

    @if(item().subItems && nestedMenuOpen() && !collapsed()) {
        <div class="nested-menu">
            @for (subItem of item().subItems; track subItem.label) {
                <a
                        mat-list-item
                        class="indented"
                        [routerLink]="item().route + '/' + subItem.route"
                        routerLinkActive="selected-menu-item"
                        #rla="routerLinkActive"
                        [activated]="rla.isActive">

                    <mat-icon matListItemIcon *ngIf="!collapsed()">{{ subItem.icon }}</mat-icon>

                    @if(!collapsed()) {
                        <span matListItemTitle>{{ subItem.label }}</span>
                    }
                </a>
            }
        </div>
    }
</ng-template>
